const API = "https://jm.komerzy.com/backend/?url=empresaapi";

const getToken = () => {
  return localStorage.getItem("token");
};

export const getEmpresa = async () => {
  try {
    const token = getToken();

    const res = await fetch(`${API}&action=listar`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    const json = await res.json();
    return json.data;
  } catch (error) {
    console.error("Error obteniendo empresa:", error);
    return null;
  }
};

export const actualizarEmpresa = async (empresa) => {
  try {
    const token = getToken();

    const res = await fetch(`${API}&action=actualizar`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(empresa),
    });

    if (!res.ok) {
      const textoError = await res.text();
      return { status: "error", message: "Error en el servidor", debug: textoError };
    }

    return await res.json();
  } catch (error) {
    console.error("Error en la petición:", error);
    return null;
  }
};

export const validarRucFactiliza = async (ruc) => {
    try {
        const token = localStorage.getItem("token") || "";
        const res = await fetch(`${API}&action=validarRuc&ruc=${ruc}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        const json = await res.json();
        return json;
    } catch (error) {
        console.error("Error consultando RUC:", error);
        return null;
    }
};
